export const OfferWantBuyStatus = Object.freeze({
    canceled: Symbol('new'),
    new: Symbol('processing'),
    processing: Symbol('completed'),
});

export function getStatusText(status) {
    return {
        [OfferWantBuyStatus.new]: 'Nowy',
        [OfferWantBuyStatus.processing]: 'Przetwarzanie',
        [OfferWantBuyStatus.completed]: 'Zakończone',
    }[OfferWantBuyStatus[status]];
}
